"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedSlotKey = exports.getSlotKey = void 0;
const keccak256_1 = require("@ethersproject/keccak256");
/**
 * Computes the EVM slot key for a specific mapping value in a contract
 * Eg the key of where the value balances['0x123...'] resides in the contract state can be found by querying
 * this function with '0x123...' and the index of the balances[] mapping in the contract.
 * @param mappingKey The mapping key of the mapping value you want to find the slot key for
 * @param slotIndex The index of the mapping in the contract, can be found from solidity compiler artifacts
 * @returns The slot key of the mapping value, a 32 byte hex string
 */
const getSlotKey = (mappingKey, slotIndex) => {
    const paddedSlot = slotIndex.slice(2).padStart(64, '0');
    const paddedMappingKey = mappingKey.slice(2).padStart(64, '0');
    return (0, keccak256_1.keccak256)(`0x${paddedMappingKey}${paddedSlot}`);
};
exports.getSlotKey = getSlotKey;
/**
 * Computes the EVM slot key for a nested mapping value in a contract
 * Eg the key of where the value balances['0x123...'][42] resides in the contract state can be found by querying
 * this function with '0x123...', 42 and the index of the balances[] mapping in the contract.
 * @param mappingKeys The mapping keys of the nested mapping you want to find the slot key for
 * @param slotIndex The index of the mapping in the contract, can be found from solidity compiler artifacts
 * @returns The slot key of the mapping values, a 32 byte hex string
 */
const getNestedSlotKey = (mappingKeys, slotIndex) => {
    const [outermostMappingKey, ...innerMappingKeys] = mappingKeys;
    let slotKey = (0, exports.getSlotKey)(outermostMappingKey, slotIndex);
    for (const innerMappingKey of innerMappingKeys) {
        slotKey = (0, exports.getSlotKey)(innerMappingKey, slotKey);
    }
    return slotKey;
};
exports.getNestedSlotKey = getNestedSlotKey;
